<template>
   <div class="navbar">
      <div class="titre">{{ titre }}</div>
      <div>
         <div class="profil" @click="menuParams = !menuParams">{{ user.charAt(0) }}</div>

         <!-- items du sous-menu  -->
         <slide-y-up-transition :duration="170" origin="center top" mode="out-in">
            <div class="menu-parametres" v-show="menuParams">
               <b-tooltip label="S'abonner à premium" type="is-dark" position="is-left">
                  <router-link :to="{ name: 'abonnement' }" @click.native="menuParams = false">
                     <div class="menu-parametres-item">
                        <div class="menu-parametres-icone">
                           <b-icon icon="crown" type="is-warning"> </b-icon>
                        </div>
                     </div>
                  </router-link>
               </b-tooltip>
               <b-tooltip label="Profil" type="is-dark" position="is-left">
                  <router-link :to="{ name: 'profil' }" @click.native="menuParams = false">
                     <div class="menu-parametres-item">
                        <div class="menu-parametres-icone">
                           <b-icon icon="account"> </b-icon>
                        </div>
                     </div>
                  </router-link>
               </b-tooltip>
               <b-tooltip label="Paramètres" type="is-dark" position="is-left">
                  <router-link :to="{ name: 'parametres' }" @click.native="menuParams = false">
                     <div class="menu-parametres-item">
                        <div class="menu-parametres-icone">
                           <b-icon icon="settings-outline"> </b-icon>
                        </div>
                     </div>
                  </router-link>
               </b-tooltip>
               <b-tooltip label="Se déconnecter" type="is-dark" position="is-left">
                  <router-link :to="{ name: 'logout' }" @click.native="menuParams = false">
                     <div class="menu-parametres-item">
                        <div class="menu-parametres-icone">
                           <b-icon icon="power"> </b-icon>
                        </div>
                     </div>
                  </router-link>
               </b-tooltip>
            </div>
         </slide-y-up-transition>

         <!-- / items du sous menu  -->
      </div>
   </div>
</template>

<script>
import { SlideYUpTransition } from 'vue2-transitions';

export default {
   name: 'Navbar',
   components: {
      SlideYUpTransition
   },
   data() {
      return {
         menuParams: false
      };
   },
   computed: {
      titre() {
         return this.$store.state.titre;
      },
      user() {
         return this.$store.state.user.data.name.toUpperCase();
      }
   }
};
</script>
